import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  TextField,
  FormControlLabel,
  Switch,
} from '@mui/material';

const todayIso = () => new Date().toISOString().split('T')[0];

const DeactivateDialog = ({ open, onClose, onConfirm }) => {
  const [date, setDate] = useState(todayIso());
  const [scheduled, setScheduled] = useState(true);

  const handleConfirm = () => onConfirm({ deactivationDate: date, scheduled });

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirmar desactivación</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          El empleado dejará de aparecer en la planificación desde la fecha fin seleccionada.
        </DialogContentText>
        <TextField
          fullWidth
          type="date"
          label="Fecha fin laboral"
          value={date}
          onChange={(event) => setDate(event.target.value)}
          InputLabelProps={{ shrink: true }}
        />
        <FormControlLabel
          sx={{ mt: 1 }}
          control={<Switch checked={scheduled} onChange={(event) => setScheduled(event.target.checked)} />}
          label="Dar de baja automáticamente en la fecha fin"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">Cancelar</Button>
        <Button onClick={handleConfirm} color="primary" disabled={!date}>Desactivar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeactivateDialog;
